// Textos extraídos da embalagem ARGMAX (podem ser editados por produto)
const PREPARO = "Usar sobre reboco, emboço, contrapiso ou alvenaria de blocos/tijolos com mais de 14 dias de cura. Superfícies secas e isentas de material desagregante. Misturar com água de boa qualidade na proporção de 4 a 5 partes de argamassa para 1 de líquido, até consistência homogênea. Descansar 15 minutos antes de usar.";
const APLICACAO = "Aplicar com desempenadeira dentada, formando cordões paralelos, espessura de até 10 mm, em áreas de aprox. 2 m² por vez. Espaçamento mínimo de 4 mm entre peças, pressionando e batendo com martelo de borracha.";

export const PACKAGING_TEMPLATES = {
  "AC-I": {
    catalog_headline: "Uso interno",
    catalog_color: "#dc2626",
    catalog_weight: "Saco 20 kg",
    catalog_indications: "Uso interno para assentamento de cerâmicas/azulejos em paredes e pisos até 45 x 45 cm.",
    catalog_application: `${PREPARO}\n${APLICACAO}`,
    catalog_technical: "Conforme NBR 14081 · Tempo em aberto: 20 a 25 min · Limpeza final: até 1 h após o assentamento · Nunca usar ácido.",
  },
  "AC-II": {
    catalog_headline: "Interno · variação térmica",
    catalog_color: "#16a34a",
    catalog_weight: "Saco 20 kg",
    catalog_indications: "Assentamento de cerâmicas/azulejos em paredes e pisos sujeitos a variações de temperatura e umidade. Não usar em áreas externas, piscinas, churrasqueiras ou câmaras frigoríficas.",
    catalog_application: `${PREPARO}\n${APLICACAO}`,
    catalog_technical: "Resistência ao arrancamento conforme NBR 13749 · Tempo em aberto: 20 a 25 min · Liberação para tráfego: após 72 h.",
  },
  "AC-III": {
    catalog_headline: "Uso interno e externo",
    catalog_color: "#ea580c",
    catalog_weight: "Saco 20 kg",
    catalog_indications: "Uso interno e externo. Próprio para piscinas, churrasqueiras e câmaras frigoríficas; porcelanatos e pisos em áreas de tráfego intenso e/ou sujeitas a variações de temperatura e umidade.",
    catalog_application: `${PREPARO}\n${APLICACAO} Cruzar os cordões no verso das peças.`,
    catalog_technical: "Resistência ao arrancamento conforme NBR 13748 · Tempo em aberto: 20 a 25 min · Liberação para pessoas: após 72 h · Cura: 7 dias.",
  },
};
